import { SSO_ERRORS, SSO_PROVIDER_ID } from "@unbox/api";
import { authClient } from "@/lib/auth-client";

const SSO_ERROR_MESSAGES: Record<string, string> = {
  account_not_linked:
    "An account with this email already exists. Sign in with your password once to connect it to your company's single sign-on.",
  [SSO_ERRORS.jitDisabled]:
    "Your company's single sign-on doesn't create new accounts. Ask your administrator for an invitation.",
  [SSO_ERRORS.notConfigured]: "Single sign-on isn't set up for your email's domain. Contact your administrator.",
  [SSO_ERRORS.accountDeactivated]: "Your account has been deactivated. Contact your administrator to restore access.",
  [SSO_ERRORS.provisioningFailed]:
    "We couldn't set up your account. Please try again, or contact support if it keeps happening.",
  email_does_not_match: "The single sign-on account you used has a different email address than this one.",
  account_already_linked_to_different_user: "That single sign-on identity is already connected to another account.",
};

export const ssoErrorMessage = (code: string) => SSO_ERROR_MESSAGES[code] ?? "Single sign-on failed. Please try again.";

const absolute = (path: string) => `${window.location.origin}${path}`;

const loginUrl = (email: string, next?: string) =>
  absolute(`/login?${new URLSearchParams({ email, ...(next ? { next } : {}) })}`);

export const signInWithSso = async (email: string, next: string) => {
  const { error } = await authClient.signIn.social({
    provider: SSO_PROVIDER_ID,
    loginHint: email,
    callbackURL: absolute(next),
    errorCallbackURL: loginUrl(email),
  });
  return error;
};

export const linkSso = async (email: string, next: string) => {
  const { error } = await authClient.linkSocial({
    provider: SSO_PROVIDER_ID,
    callbackURL: absolute(next),
    errorCallbackURL: loginUrl(email, next),
  });
  return error;
};
